import { render } from "./base-pagination.vue?vue&type=template&id=2882b9c0"
import script from "./base-pagination.vue?vue&type=script&lang=js"
export * from "./base-pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__